const initialState = {
  app: null,
  companyCode: null,
  companyCodes: [],
  featureFlags: {},
  isFetchingCompanyCodes: false,
  fetchingInitialProvisionData: false,
  fetchingPriovisionData: false,
  isError: false,
  errorMessage: null,
  isInitialDataLoaded: false,
  provisionData: null,
  companyCodesFilter: '',
  period: null,
  currentPeriod: null,
  periods: [],
  countryTaxType: '',
  entryType: '',
  activity: '',
  bookType: 'P',
  bookTypes: [],
  bookTypesFetching: false,
  taxYear: { value: '-1', name: 'All' },
  taxYears: [],
  connection: null,
  connections: [],
  alert: {
    show: false,
    content: '',
    alertType: '',
  },
  reportingCurrencyCodes: [],
  reportingCurrencyCode: '',
  countryTaxTypeDescriptions: null,
  isFetchingCountryTaxTypeDescriptions: false,
  yearStartPeriod: null,

  categories: [],
  isLoadingCategories: false,
  calculationIdList: [],
  connectionsByType: [],
};

export default initialState;
